// extracted by mini-css-extract-plugin
module.exports = {"WhyVidyalayaOffer":"WhyVidyalayaOffer_WhyVidyalayaOffer__g9n5B","conetext-div":"WhyVidyalayaOffer_conetext-div__pvgU_"};